import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import ApiServer from "../ApiServer.ts";
import * as i18n from "../i18n.ts";
import * as modal from "../util/modal.ts";
import * as libLocation from "../lib/location.ts";
import * as Storage from "../lib/Storage.ts";
import * as actionMenu from "../widget/action-menu-registry.ts"
import * as handlebars_family from "../handlebars_family.ts";

import TPL from "../mealplanner/recipeDetailShared.mustache";

var theRecipe;

function onApiError(error){
  modal.alert("fw2.defaultError")
}

function displayRecipe(recipe){
  theRecipe = recipe;
  recipe.rights.canUpdate = false;
  recipe.rights.canDelete = false;
  recipe.canShare = false;
  recipe.canAdd = false;
  recipe.hasCategories = false;
  recipe.signinlink = '<span class="color-branded" data-fw-onclick="ncsaverecipe|signin">'+i18n.get("mp.sharedsignin")+'</span>';
  recipe.registerlink = '<span class="color-branded" data-fw-onclick="ncsaverecipe|register">'+i18n.get("mp.sharedregister")+'</span>';



  Html.setHtml(document.getElementById('recipe-container'),TPL,recipe);
}

INR.onPage(INR.URL.RECIPEBOX_NC,function(){
  let
    token = libLocation.getURLParam("v"),
    recipeId = libLocation.getURLParam("metaId");
  ApiServer.mpncrecipe(token,recipeId,displayRecipe,onApiError)
});

Html.registerDom({
  ncsaverecipe:function(target){
    Storage.sessionSet('recipeToSave',JSON.stringify(theRecipe.originalJson))
    if(target==='register'){
      libLocation.goTo('fw2_signup.php');
    }else{
      libLocation.goTo('fw2_signin.php');
    }

  }
})
actionMenu.register({
  recipesharedsave(){
    var result = '&nbsp;&nbsp;&nbsp;'+handlebars_family.transform(i18n.get('mp.sharedinvitesave'),theRecipe)+'&nbsp;&nbsp;&nbsp;'
    return {menu:[{html:result}]}
  }
})